module.exports = {"630106001":"康川街道","630106100":"田家寨镇","630106101":"上新庄镇","630106102":"鲁沙尔镇","630106103":"甘河滩镇","630106104":"共和镇","630106105":"多巴镇","630106106":"拦隆口镇","630106107":"上五庄镇","630106108":"李家山镇","630106109":"西堡镇","630106200":"群加藏族乡","630106201":"土门关乡","630106202":"汉东回族乡","630106203":"大才回族乡","630106204":"海子沟乡","630106400":"甘河工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630106.json
// module id = 3122
// module chunks = 0